import { IPagination, IPaginationDTO } from './pagination.model';

export enum SubscriptionsEndpoints {
  SUBSCRIPTIONS = '/subscribers',
  EXPORT_SUBSCRIPTIONS = '/subscribers/export',
}

export interface ISubscription {
  id: string;
  email: string;
  created_at: string;
}

// ----------------- DTOs ----------------

export interface IGetSubscriptionsDTO extends Partial<IPaginationDTO> {
  email?: string;
  date_from?: string;
  date_to?: string;
}

export interface IDeleteSubscriptionDTO {
  id: string;
}

// ------------ Responses --------------

export interface IGetSubscriptionsResponse {
  data: ISubscription[];
  meta: IPagination;
}

export interface IExportSubscriptionsResponse {
  data: {
    url: string;
  };
}
